import { render, staticRenderFns } from "./CreateV2.vue?vue&type=template&id=31b0d8a6&scoped=true"
import script from "./CreateV2.vue?vue&type=script&lang=js"
export * from "./CreateV2.vue?vue&type=script&lang=js"
import style0 from "./CreateV2.vue?vue&type=style&index=0&id=31b0d8a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31b0d8a6",
  null
  
)

export default component.exports